export function parseIntOrDefault<T>(str: string | undefined | null | number, def: T): number | T {
  const int = parseInt(`${str}`, 10);
  if (Number.isNaN(int)) {
    return def;
  }
  return int;
}

export function parseIntOrUndefined(str: string | undefined | null | number): number | undefined {
  return parseIntOrDefault(str, undefined);
}

export function parseIntOrThrow(str: string | undefined | null | number): number {
  const int = parseInt(`${str}`, 10);
  if (Number.isNaN(int)) {
    throw new Error(`Failed to parse integer from value: ${str}`);
  }
  return int;
}

export function parseFloatOrDefault<T>(str: string | undefined | null | number, def: T): number | T {
  const Float = parseFloat(`${str}`);
  if (Number.isNaN(Float)) {
    return def;
  }
  return Float;
}

export function parseFloatOrUndefined(str: string | undefined | null | number): number | undefined {
  return parseFloatOrDefault(str, undefined);
}

export function parseFloatOrThrow(str: string | undefined | null | number): number {
  const Float = parseFloat(`${str}`);
  if (Number.isNaN(Float)) {
    throw new Error(`Failed to parse Floateger from value: ${str}`);
  }
  return Float;
}
